import React, { useState } from 'react';
import LandingPage from './components/LandingPage';
import VideosPage from './components/VideosPage';
import LearnPage from './components/LearnPage';
import AboutPage from './components/AboutPage';
import VideoPlayerPage from './components/VideoPlayerPage';
import './App.css';

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [selectedVideo, setSelectedVideo] = useState(null);

  const navigateTo = (page) => {
    setCurrentPage(page);
  };

  const playVideo = (video) => {
    setSelectedVideo(video);
    setCurrentPage('video-player');
  };

  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <LandingPage navigateTo={navigateTo} playVideo={playVideo} />;
      case 'videos':
        return <VideosPage navigateTo={navigateTo} playVideo={playVideo} />;
      case 'learn':
        return <LearnPage navigateTo={navigateTo} />;
      case 'about':
        return <AboutPage navigateTo={navigateTo} />;
      case 'video-player':
        return <VideoPlayerPage navigateTo={navigateTo} video={selectedVideo} />;
      default:
        return <LandingPage navigateTo={navigateTo} playVideo={playVideo} />;
    }
  };

  return (
    <div className="App">
      {renderPage()}
    </div>
  );
}

export default App;